<template>
  <div class="wu-root">
    <transition name="fade">
      <div v-if="widgfinishvis">
        <WidgFinish />
      </div>
    </transition>

    <transition name="fade">
      <div v-if="widguservis" class="wu-wrapper">
        <div class="wu-card">
          <!-- Header -->
          <div class="wu-header">
            <div class="wu-icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4a7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
            <h4 class="wu-title">
              <span class="wu-title--accent">Awesome!</span> Let's get your info
            </h4>
            <p class="wu-subtitle">We just need a couple of details to continue</p>
          </div>

          <!-- Form -->
          <div class="wu-form">
            <!-- Phone -->
            <div class="wu-field">
              <label class="wu-label">Phone Number</label>
              <div class="wu-input-wrap">
                <svg class="wu-input-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <input
                  id="phone_number"
                  ref="phone_number"
                  v-model="input.phone_number"
                  type="text"
                  class="wu-input wu-input--icon"
                  placeholder="(123) 456-7890"
                />
              </div>
            </div>

            <!-- Email -->
            <div class="wu-field">
              <label class="wu-label">Email Address</label>
              <div class="wu-input-wrap">
                <svg class="wu-input-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <input
                  id="email"
                  v-model="input.email"
                  type="email"
                  name="email"
                  class="wu-input wu-input--icon"
                  placeholder="you@example.com"
                />
              </div>
            </div>

            <!-- Errors -->
            <transition name="fade">
              <div v-if="errors.length" class="wu-errors">
                <div class="wu-errors__header">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                    <line x1="12" y1="9" x2="12" y2="13" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                  </svg>
                  <span>Please fix the following:</span>
                </div>
                <ul class="wu-errors__list">
                  <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
                </ul>
              </div>
            </transition>

            <!-- Submit -->
            <button class="wu-btn" @click="checkForm">
              Submit
            </button>
          </div>

          <!-- Trust -->
          <div class="wu-trust">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
              <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
            <span>Your information is secure and encrypted</span>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div v-if="visible" class="vue-back-to-top" :style="`bottom:${this.bottom};left:${this.left};`">
        <Main />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'WidgUser',

  data() {
    return {
      address: 'Address',
      country: 'Country',
      city: 'City',
      zip_code: 'Zip Code',
      province: 'Province',
      employment: 'Employment',
      step: 4,
      errors: [],
      widguservis: true,
      widgfinishvis: false,
      vendorOfUser: '',
      numberOfPayments: 12,
      frequency: '',
      currentYear: '',
      loanRatio: '',
      approvedLoan: '',
      maxLoanAmount: '',
      finalLoanAmount: '',
      repairAmount: '',
      boundaryLimit: '',
      minimumLoan: '',
      visible: false,
      input: {
        first_name: 'First Name',
        last_name: 'Last Name',
        email: null,
        phone_number: null,
        password: Math.random().toString(36).slice(-5),
      },
      show: false
    }
  },
  mounted() {
    this.$refs.phone_number.focus();
    const {
      year,
      make,
      model,
      trim: trim_level,
      vehicleStyle: vehicle_style,
      vin,
      odometerReading: odometer_reading,
      carDetails: car_details,
      payment: loan_amount,
      paymentFrequency: frequency,
      numberOfPayments: number_of_payments,
      paymentTotal: payment_total,
      boundaryAmount: boundary_amount,
      approvedLoanAmount: max_loan_amount,
      loanRequested: loan_requested,
      repairOfferAmount: repair_offer_amount,
      paymentPeriod: term,
      newAPR: new_apr,
      vendorToPay: vendor_to_pay,
      firstPaymentDay: first_payment_day,
      totalPayments: total_payments,
      costOfFinancing: cost_of_financing,
      frequencyText: frequency_text,
      paymentFees: payment_fees,
      selectedProduct: selected_product,
      productPrice: product_price,
      vendor,
    } = this.$store.state.userData
  },
  created() {

    console.log('the vendor is' + this.$store.state.userData.selectedVendor)
    console.log(this.$store.state.userData)
    this.vendorOfUser = this.$store.state.userData.selectedVendor
    this.currentYear = new Date().getFullYear()
    this.loanRatio = 1 - (this.currentYear - this.$store.state.userData.year) / 35
    this.approvedLoan = Math.max(1500, (Math.trunc((this.$store.state.userData.marketValue * 0.3 * 0.7) * this.loanRatio)))
    this.repairAmount = this.$store.state.userData.repairOfferAmount
    // Check the maximum amount possible to take if the approved loan is lower than the repair offer
    this.maxLoanAmount =
      this.approvedLoan > this.repairAmount ? this.repairAmount : this.approvedLoan
    this.boundaryLimit = this.maxLoanAmount > 10000 ? 10000 : this.maxLoanAmount
    // Check if the customer needs to bring cash because his approved amount doesn't cover the repair offer
    this.minimumLoan =
      this.approvedLoan > this.repairAmount ? 500 : this.repairAmount - this.approvedLoan
    // set default highest loan possible
    this.finalLoanAmount = this.boundaryLimit
    // store the data
    this.$store.state.userData.boundaryAmount = this.approvedLoan > 10000 ? 10000 : this.approvedLoan
    this.$store.state.userData.paymentTotal = this.finalLoanAmount
    this.frequency = this.$store.state.userData.frequency
    // is the below line important?
  },
  watch: {
    'input.email': {
      handler: function(after, before) {
        this.input.email = this.input.email.toLowerCase()
      },
      deep: true
    }
  },
  methods: {
    onpicOne() {
      if ('parentIFrame' in window)
        window.parentIFrame.size(256);
      return false;
    },
    closewidg() {
      if ('parentIFrame' in window)
        window.parentIFrame.size(70);
      return false;
    },
    closeWin() {
      return [this.widguservis = false, this.visible = true, widgfinishvis = false]
    },    cleanPhone(val) {
      if (!val) return ''
      return val.replace(/[^\d+]/g, '')
    },
    validPhone(phone) {
      const digits = this.cleanPhone(phone)
      return digits.length >= 10 && digits.length <= 15
    },    validEmail: function(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    checkForm: function(e) {
      console.log('selected vendor' + this.selectedVendor);
      this.errors = [];
      if (!this.input.first_name) {
        this.errors.push("First Name required.");
      }
      if (!this.input.last_name) {
        this.errors.push("Last Name required.");
      }
      if (!this.input.password) {
        this.errors.push("Password required.");
      }
      if (!this.input.phone_number) {
        this.errors.push('Phone number required.');
      } else if (!this.validPhone(this.input.phone_number)) {
        this.errors.push('Valid phone number required (10-15 digits).');
      }
      if (!this.input.email) {
        this.errors.push('Email required.');
      } else if (!this.validEmail(this.input.email)) {
        this.errors.push('Valid email required.');
      }
      if (!this.errors.length) {
        console.log('creating user');
                this.axios
                .post(`${process.env.ROOT_API}/user/create`, {
                  first_name: this.input.first_name,
                  last_name: this.input.last_name,
                  email: this.input.email,
                  password: this.input.password,
                  vendor_of_user: this.vendorOfUser,
                  phone_number: this.cleanPhone(this.input.phone_number)
                })
          .then(response => {
            localStorage.setItem('user-id', response.data.data.id)
            localStorage.setItem('user-token', response.data.data.token)
            const id = localStorage.getItem('user-id')
            const token = localStorage.getItem('user-token')
            console.log('updating user');
            const updateUserPromise = this.axios.put(
              `${process.env.ROOT_API}/user/${id}`,
              {
                address: this.address,
                city: this.city,
                zip_code: this.zip_code,
                province: this.province,
                country: this.country,
                employment: this.employment,
              }, {
                headers: {
                  authorization: `Token ${token}`,
                },
              }
            )
            const {
              year,
              make,
              model,
              trim: trim_level,
              vehicleStyle: vehicle_style,
              vin,
              loanRequested: amount,
              odometerReading: odometer_reading,
              carDetails: car_details,
              payment: loan_amount,
              paymentFrequency: frequency,
              numberOfPayments: number_of_payments,
              paymentTotal: payment_total,
              boundaryAmount: boundary_amount,
              approvedLoanAmount: max_loan_amount,
              loanRequested: loan_requested,
              repairOfferAmount: repair_offer_amount,
              paymentPeriod: term,
              newAPR: new_apr,
              vendorToPay: vendor_to_pay,
              firstPaymentDay: first_payment_day,
              totalPayments: total_payments,
              costOfFinancing: cost_of_financing,
              frequencyText: frequency_text,
              paymentFees: payment_fees,
              selectedProduct: selected_product,
              productPrice: product_price,
              selectedVendor: vendor,
            } = this.$store.state.userData
            const createLoanPromise = this.axios.post(
              `${process.env.ROOT_API}/user/loan/create`,
              {
                make,
                model,
                year,
                trim_level,
                vin,
                car_details,
                vehicle_style,
                odometer_reading,
                loan_amount,
                frequency,
                number_of_payments,
                payment_total,
                boundary_amount,
                max_loan_amount,
                loan_requested,
                repair_offer_amount,
                term,
                new_apr,
                vendor_to_pay,
                first_payment_day,
                total_payments,
                cost_of_financing,
                frequency_text,
                selected_product,
                product_price,
                vendor,
              }, {
                headers: {
                  authorization: `Token ${token}`,
                },
              }
            )
            Promise.all([updateUserPromise, createLoanPromise]).then(() => {
              location.href = `${process.env.DASHBOARD_URL}/#/login?token=${token}`

              // this.showCompleted = true
              // this.$store.commit('setStep');
              // return this.showCompleted
            }).catch(error => {
              if (error.message === 'Request failed with status code 409') {
                this.$toasted.show('Dashoad could not be loaded')
              } else {
                this.$toasted.show('An error occurred please try again')
              }
            })
          }).catch(error => {
            if (error.message === 'Request failed with status code 409') {
              this.$toasted.show('User with this email already exists')
            } else {
              this.$toasted.show('An error occurred please try again')
            }
          })
        this.widguservis = false;
        this.widgfinishvis = true;
        this.onpicOne();
      }

      e.preventDefault();
    },

  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

/* ── Root ── */
.wu-root {
  font-family: 'Inter', sans-serif;
}

/* ── Wrapper ── */
.wu-wrapper {
  display: flex;
  justify-content: center;
  padding: 0 12px;
}

/* ── Card ── */
.wu-card {
  width: 100%;
  max-width: 440px;
  background: #fff;
  border-radius: 22px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.07);
  padding: 32px 28px 28px;
}

/* ── Header ── */
.wu-header {
  text-align: center;
  margin-bottom: 24px;
}

.wu-icon-wrap {
  width: 52px;
  height: 52px;
  margin: 0 auto 10px;
  border-radius: 50%;
  background: #eef3ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wu-title {
  font-weight: 700;
  font-size: 20px;
  color: #1e2a3a;
  margin: 0 0 4px;
  text-transform: none;
}

.wu-title--accent {
  color: #34d399;
  font-weight: 800;
}

.wu-subtitle {
  font-size: 13px;
  color: #8a94a6;
  margin: 0;
}

/* ── Form ── */
.wu-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.wu-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.wu-label {
  font-size: 12px;
  font-weight: 600;
  color: #5a6478;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0;
}

/* ── Input ── */
.wu-input-wrap {
  position: relative;
}

.wu-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.wu-input {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #e0e4ec;
  background: #f8f9fb;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #1e2a3a;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}

.wu-input--icon {
  padding-left: 40px;
}

.wu-input::placeholder {
  color: #cdd3de;
}

.wu-input:focus {
  border-color: #4a7cff;
  box-shadow: 0 0 0 3px rgba(74, 124, 255, 0.12);
  background: #fff;
}

/* ── Errors ── */
.wu-errors {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  padding: 12px 14px;
}

.wu-errors__header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #dc2626;
  margin-bottom: 6px;
}

.wu-errors__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.wu-errors__list li {
  font-size: 12px;
  color: #b91c1c;
  padding-left: 22px;
  position: relative;
}

.wu-errors__list li::before {
  content: '•';
  position: absolute;
  left: 8px;
  color: #fca5a5;
}

/* ── Button ── */
.wu-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #4a7cff 0%, #6366f1 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: transform 0.12s, box-shadow 0.12s, opacity 0.2s;
  margin-top: 4px;
}

.wu-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(74, 124, 255, 0.25);
}

.wu-btn:active {
  transform: scale(0.98);
}

/* ── Trust ── */
.wu-trust {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 16px;
  font-size: 11px;
  font-weight: 500;
  color: #b0b7c3;
}

/* ── Misc ── */
.vue-back-to-top {
  z-index: 1000;
  cursor: pointer;
  position: fixed;
  left: 0;
}

/* ── Transitions ── */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ── Responsive ── */
@media (max-width: 480px) {
  .wu-card {
    padding: 24px 18px 22px;
    border-radius: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/widguser.vue